import { useEffect, useState } from 'react';
import * as Sentry from '@sentry/react';
import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { useGetMinimumAppBuildQuery } from '../main/ducks';
import { isNative } from './platform';

export type MinimumAppBuild = { ios: number | null; android: number | null };

/** Fails open: an unknown build or minimum never blocks the app. */
export const isBuildBelowMinimum = (build: string | undefined, minimum: number | null | undefined) =>
    minimum != null && /^\d+$/.test(build ?? '') && Number(build) < minimum;

/** Whether this binary is older than the oldest store build the backend still supports. */
export const useNativeUpdateRequired = () => {
    const [build, setBuild] = useState<string>();
    const { data } = useGetMinimumAppBuildQuery(undefined, { skip: !isNative() });

    useEffect(() => {
        if (!isNative()) return;
        App.getInfo()
            .then((info) => setBuild(info.build))
            .catch((error: unknown) => Sentry.captureException(error));
    }, []);

    const platform = Capacitor.getPlatform() as keyof MinimumAppBuild;
    return isBuildBelowMinimum(build, (data as MinimumAppBuild | undefined)?.[platform]);
};
